import { render, staticRenderFns } from "./ParagraphSkeleton.vue?vue&type=template&id=70f6c9fc&scoped=true"
import script from "./ParagraphSkeleton.vue?vue&type=script&lang=js"
export * from "./ParagraphSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ParagraphSkeleton.vue?vue&type=style&index=0&id=70f6c9fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6c9fc",
  null
  
)

export default component.exports